import React from 'react'

const searchicon = () => (
    <svg version="1.1" xmlns="https://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 61.3 61.3">
        <circle className="st0" cx="25.1" cy="25.1" r="22.6"/>
        <g>
            <line className="st1" x1="41" y1="41" x2="58.8" y2="58.8"/>
        </g>
    </svg>
); 
export default searchicon;